import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u12",
  "use": "icon-u12-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-u12\">\n  <g transform=\"matrix(1 0 0 1 0 -18 )\">\n    <path d=\"M 7 18  C 10.92 18  14 21.08  14 25  C 14 28.92  10.92 32  7 32  C 3.08 32  0 28.92  0 25  C 0 21.08  3.08 18  7 18  Z \" fill-rule=\"nonzero\" fill=\"#f4cb79\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol